<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "kasa"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/icra.vue